import { FC, JSX } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { IconName } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import { partTestId } from '@connect-x-app/shared-utils';
import classNames from 'classnames';

import { Avatar } from '../avatar';
import { Icon } from '../icon';

import './flightroomInfoItem.scss';

type Props = {
  avatar: IconName;
  onClick?: () => void;
  rightSection?: JSX.Element;
  subValue?: string | null;
  testId?: string;
  title: string;
  titleIcon?: JSX.Element | null;
  value: string;
};

export const FlightroomInfoItem: FC<Props> = ({ avatar, onClick, rightSection, subValue, testId, title, titleIcon, value }) => {
  const isClickable = !!onClick;

  const handleClick = () => {
    if (!isClickable) {
      return;
    }
    onClick?.();
  };

  return (
    <div
      className={classNames('flightroom-info-item-container', isClickable && 'clickable')}
      data-test={testId}
      onClick={handleClick}
      role="presentation"
    >
      <section className="flightroom-info-icon">
        <Avatar icon={avatar} isDisabled testId={partTestId(testId, 'avatar')} />
      </section>
      <section className="flightroom-info-text">
        <div className="flex-row">
          {titleIcon}
          <Text color={COLORS.romeo.$07} size="SM" testID={partTestId(testId, 'title')} weight="bold">
            {title}
          </Text>
        </div>
        <Text color={COLORS.zulu.$08} size="SM" testID={partTestId(testId, 'value')}>
          {value}
        </Text>
        {subValue ? (
          <Text color={COLORS.zulu.$08} size="XS" testID={partTestId(testId, 'subValue')}>
            {subValue}
          </Text>
        ) : null}
      </section>
      <section className="flightroom-info-right">
        {rightSection}
        {isClickable && <Icon colorName={COLORS.bogota.$04} name="chevronRight" testId={partTestId(testId, 'chevron')} />}
      </section>
    </div>
  );
};
